window.initLearnSlider ?? (() => {
    window.initLearnSlider = (section_id) => {
        const learnSliderSection = document.querySelector(`section#shopify-section-${section_id} .careline-20-learn`);

        function getAfterOffset() {
            const styles = window.getComputedStyle(learnSliderSection);
            const paddingLeft = parseFloat(styles.paddingLeft);
            const containerWidth = Math.min(learnSliderSection.offsetWidth, window.innerWidth);
            const viewportWidth = window.innerWidth;
            const outerMargin = Math.max((viewportWidth - containerWidth) / 2, 0);
            return (outerMargin + paddingLeft > 200)? outerMargin + paddingLeft : 200;
        }

        const swiper = new Swiper('.careline-20-learn-swiper', {
            slidesPerView: 1.3,
            spaceBetween: 15,
            overflow: 'visible',
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: false,
            //slidesOffsetAfter: getAfterOffset(),
            breakpoints: {
                500: {
                    slidesPerView: 1.85,
                    spaceBetween: 15,
                },
                750: {
                    slidesPerView: 2.65,
                    spaceBetween: 15,
                },
                990: {
                    slidesPerView: 3.2,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                }
            }
        });

        window.addEventListener('resize', () => {
            swiper.params.slidesOffsetAfter = getAfterOffset();
            swiper.update();
        });
    }
  
})();